const WishlistButtonSkeleton = () => {
  return <div className='h-6 w-6 animate-pulse bg-gray-200' data-sentry-component="WishlistButtonSkeleton" data-sentry-source-file="skeleton.tsx" />;
};
export default WishlistButtonSkeleton;